/**
 * Grocery list generation, store sorting and check-off expiration defaults —
 * public types (PLAN §4.3–4.5, decisions D6/D10/D12).
 *
 * SYNC RULE: `INGREDIENT_CATEGORIES`, `DEPARTMENTS` and `LOCATION_TYPES` below
 * must stay identical to `INGREDIENT_CATEGORIES` in
 * `packages/schema/src/ingredients.ts` and `DEPARTMENTS` / `LOCATION_TYPES` in
 * `packages/schema/src/stores.ts`. `packages/core` is deliberately
 * dependency-free (it runs on the server and inside the phone apps), so these
 * vocabularies are duplicated here rather than imported — exactly as
 * `units.ts` duplicates `UNIT_KEYS` and `timeline/types.ts` duplicates
 * `EQUIPMENT_KINDS`.
 *
 * Field names mirror `groceryItemDtoSchema` in `packages/schema/src/groceries.ts`
 * so the API can map a `GroceryListItem` onto the wire format without renaming.
 */
export const INGREDIENT_CATEGORIES = [
    'produce',
    'meat',
    'seafood',
    'dairy',
    'bakery',
    'pantry',
    'frozen',
    'spices',
    'beverages',
    'other',
];
export const DEPARTMENTS = [
    'produce',
    'deli',
    'bakery',
    'butcher',
    'seafood',
    'aisles',
    'dairy',
    'frozen',
    'other',
];
export const LOCATION_TYPES = ['aisle', 'endcap', 'department'];
/**
 * Why a line could not be fully converted.
 *
 * SYNC RULE: identical to `UNCONVERTED_REASONS` in `packages/schema/src/groceries.ts`.
 */
export const UNCONVERTED_REASONS = [
    'missing_density',
    'missing_unit_weight',
    'incompatible_units',
];
//# sourceMappingURL=types.js.map